/* eslint-disable no-console */
import { emitPageView } from 'store/userEnvironment/userEnvironmentActions';
import { createPageViewEvent } from '../eventCreators';
import { createPageViewEventPayload } from '../dataHelpers/createPageViewEventPayload';

const emitPageViewEvent = ({ payload }) => {
  const qffPoints = payload.qffPoints ? Number(payload.qffPoints) : undefined;

  const pageViewEvent = createPageViewEvent(
    createPageViewEventPayload({
      pageType: payload.pageType,
      pageTitle: document.title,
      location: location.href,
      referrer: document.referrer,
      siteId: 'hotels',
      siteVertical: 'travel',
      user: {
        isLoggedIn: payload.isLoggedIn,
        ...(payload.isLoggedIn && {
          userId: payload.qf_value || '',
          qffHashId: payload.qf_value || '',
          qffPoints,
        }),
        ...(!payload.isLoggedIn && {
          userId: '',
          qffHashId: payload.qf_value || '',
        }),
      },
    }),
  );
  return pageViewEvent;
};

export default { [emitPageView]: emitPageViewEvent };
